import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as l, createElementBlock as d, normalizeClass as n, createElementVNode as o } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconRematch",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(r).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, m = ["aria-label", "data-qa", "aria-hidden"];
function u(e, t, i, _, f, a) {
  return l(), d("svg", {
    "aria-label": i.ariaLabel,
    class: n([a.iconSizeClass, "d-icon d-icon--rematch"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Rematch",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M6 2a3.877 3.877 0 0 0-3.877 3.877.5.5 0 1 1-1 0A4.877 4.877 0 0 1 6 1h.002a5.242 5.242 0 0 1 3.624 1.473l.006.006.245.245V1.5a.5.5 0 1 1 1 0v2.432a.5.5 0 0 1-.5.5H7.945a.5.5 0 0 1 0-1H9.17l-.242-.243a4.242 4.242 0 0 0-2.929-1.19Zm4.377 3.623a.5.5 0 0 1 .5.5A4.877 4.877 0 0 1 6 11h-.002a5.242 5.242 0 0 1-3.624-1.473l-.006-.006-.245-.246V10.5a.5.5 0 0 1-1 0V8.068a.5.5 0 0 1 .5-.5h2.431a.5.5 0 0 1 0 1H2.83l.242.243A4.242 4.242 0 0 0 6.001 10a3.877 3.877 0 0 0 3.876-3.878.5.5 0 0 1 .5-.5Z",
      fill: "currentColor"
    }, null, -1)
  ])], 10, m);
}
const b = /* @__PURE__ */ s(c, [["render", u]]);
export {
  b as default
};
//# sourceMappingURL=rematch.js.map
